export const isLocation = term => {
  const address = term.split(",");
  const hasAddress =
    address.length === 2 &&
    address.every(location => !isNaN(parseFloat(location)));
  const geocode = term.trim().split(" ");
  const hasGeocode =
    geocode.length === 2 && geocode.every(code => !isNaN(parseFloat(code)));

  return hasAddress || hasGeocode;
};
